// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"96508705b68d405c542d","913":"603ba7943d49efbd73aa"}[chunkId] + ".js";
};